import React, { useState } from "react";
import styles from "./index.module.scss";
import Footer from "../../Footer";
import Header from "../../Header";
import PlatformWrap from "../../PlatformWrap";
import useDeviceType from "../../../Utils/useDeviceType";
import MHeader, { MHeaderProps } from "../../MHeader";
import { useHistory } from "react-router-dom";
import { SubLayoutContext } from "./context";
import Boundary from "../../Boundary";
import classNames from "classnames";

interface SubLayoutProps {
    className?: string;
    children: React.ReactNode;
}

export function SubLayout({ children, className }: SubLayoutProps) {
    const { isMobile } = useDeviceType();

    const history = useHistory();

    const [headerProps, setHeaderProps] = useState<MHeaderProps>({
        title: "",
        goBack: () => history.goBack()
    });

    function onHeaderPropsChange(props: Partial<MHeaderProps>) {
        setHeaderProps(oldProps => ({ ...oldProps, ...props }));
    }

    return (
        <SubLayoutContext.Provider
            value={{ headerProps, setHeaderProps: onHeaderPropsChange }}>
            <div className={classNames(styles.root, className)}>
                {isMobile ? (
                    <MHeader
                        title={headerProps.title}
                        goBack={headerProps.goBack}
                        extra={headerProps.extra}
                    />
                ) : (
                    <Header />
                )}

                <div className={styles.body}>
                    <Boundary>{children}</Boundary>
                </div>

                <PlatformWrap pc={<Footer />} />
            </div>
        </SubLayoutContext.Provider>
    );
}
